import * as React from 'react';
import * as styles from './styles.css';
import { Image, useDeviceType } from '@cian/ui-kit';
import { HeaderLink } from './components/HeaderLink';
import logo from '../../assets/images/logo.svg';
import cn from 'clsx';

export interface IHeaderProps {
  withBackground: boolean;
  links: { href: string; name: string; isActive: boolean; withBorder?: boolean }[];
}

export const Header: React.FC<IHeaderProps> = props => {
  const deviceType = useDeviceType();
  const { links, withBackground } = props;

  return (
    <header className={cn(styles['container'], styles[deviceType], withBackground && styles['with-background'])}>
      <div className={styles['content']}>
        <div className={cn(styles.logo, styles[deviceType])}>
          <Image src={logo} width="100%" height="100%" />
        </div>
        <ul className={styles['links']}>
          {links.map(link => (
            <li key={link.name}>
              <HeaderLink href={link.href} name={link.name} isActive={link.isActive} />
            </li>
          ))}
        </ul>
      </div>
    </header>
  );
};

Header.displayName = 'Header';
